export enum LabelPositions {
  top = 'top',
  bottom = 'bottom',
  left = 'left',
  right = 'right',
}
